import * as React from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function SimpleLoader() {
  const loaderState = useSelector((state) => state.commonState.loaderState);

  return (
    <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: "9999",
          backgroundColor: "#e3e2e6ed",
        }}
        open={loaderState.show}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: "1rem",
          }}
        >
          <CircularProgress
            size={65}
            sx={{
              color: "#6d4cb1",
              zIndex: 1,
            }}
          />
          <Typography variant="p" sx={{ color: "#6d4cb1" }}>
            {loaderState && loaderState.msg}
          </Typography>
        </Box>
      </Backdrop>
    </div>
  );
}
